import React, {useState, useEffect} from "react";
import { Button, Paper, TextField, Typography } from '@mui/material';
import { useAuth } from "../../Context/AuthContext";
import Alerta from "../../../components/Alerta";
import { db } from "../../../firebase/firebaseConfig";
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';

const FormularioInfoInicio = ({infoInicioSeleccionado}) => {
    const isItem = true;
    const [titulo, setTitulo] = useState('');
    const [subtitulo, setSubtitulo] = useState('');
    const {usuario} = useAuth();
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [modoEdicion, setModoEdicion] = useState(false); // Variable de estado para el modo de edición

    useEffect(() => {
        const obtenerInfoInicio = async () => {
          if (!infoInicioSeleccionado) return; // Asegúrate de que haya un infoInicioSeleccionado seleccionado
          try {
            const infoInicioDoc = await getDoc(doc(db, 'infoiniciocalocho', infoInicioSeleccionado));
            if (infoInicioDoc.exists()) {
                setModoEdicion(true);
                const infoInicioData = infoInicioDoc.data();
                setTitulo(infoInicioData.titulo || '');
                setSubtitulo(infoInicioData.subtitulo || '');
            } else {
              console.log('No se encontró el documento');
              setModoEdicion(false);
            }
          } catch (error) {
            console.error('Error al obtener el documento:', error);
          }
        };
      
        obtenerInfoInicio();
    }, [infoInicioSeleccionado]); // Asegúrate de que useEffect se ejecute cuando cambie infoInicioSeleccionado
      
    const handleChange = (e) => {
        if(e.target.name === 'titulo'){
            setTitulo(e.target.value);
        } else if(e.target.name === 'subtitulo'){
            setSubtitulo(e.target.value);
        }
    }
    

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
            if(modoEdicion && infoInicioSeleccionado.id){
                setModoEdicion(false);
                
                // Limpiar el formulario después de agregar el infoinicio
                setTitulo('');
                setSubtitulo('');
                infoInicioSeleccionado('');
                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'infoiniciocalocho actualizado correctamente' });
            
            } else {
                
                try{
                    // Agregar el infoinicio a Firestore con la URL de la imagen
                    await addDoc(collection(db, 'infoiniciocalocho'), {
                        titulo: titulo,
                        subtitulo: subtitulo,
                        uidUsuario: usuario.uid
                    });

                    // Limpiar el formulario después de agregar el infoiniciocalocho
                    setTitulo('');
                    setSubtitulo('');

                    // Mostrar mensaje de éxito
                    setEstadoAlerta(true);
                    setAlerta({ tipo: 'exito', mensaje: 'infoinicio agregado correctamente' });
                } catch(e){
                    console.log('Error ', e);
                }
            }

            // Limpiar el formulario después de agregar el infoinicio
            setTitulo('');
            setSubtitulo('');

        } catch (error) {
            console.error(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Error al agregar el infoinicio' });
        }
    }

    return (
        <Paper component="form" onSubmit={handleSubmit} sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: '500px',
            margin: 'auto',
            padding: 2,
            boxShadow: 3,
            borderRadius: 2,
            gap: 2,
            // Añadimos media queries aquí
            '@media (max-width: 1024px)': { // Tablets
                width: '85%',  // Ocupar un poco más de ancho
                padding: 1,  // Reducir el padding
            },
            '@media (max-width: 600px)': {  // Móviles
                width: '100%',  // Ocupar todo el ancho
                padding: 1,  // Padding más pequeño
            },
        }}>
            <Typography variant='h5' sx={{
                width: 'auto',
                alignItems: 'center',
                textAlign: 'center',
                '@media (max-width: 600px)': {  // En móviles, reducir el tamaño del texto
                    fontSize: '1.25rem',  // Ajustamos el tamaño de la fuente
                }
            }}>Nuestra infomación de la página inicio</Typography>

            <TextField                  
                required
                size="small"
                id="titulo"
                fullWidth
                label="Título de la información inicio"
                name="titulo"
                value={titulo}
                onChange={handleChange}
            />
            <TextField                  
                required
                size="small"
                fullWidth
                id="subtitulo"
                label="Subtitulo"
                name="subtitulo"
                value={subtitulo}
                onChange={handleChange}
            />

            <Button item={isItem.toString()} xs={12} sm={6}           
                type="submit"
                size="small"
                fullWidth
                variant="outlined"
            >{infoInicioSeleccionado ? 'Editar información' : 'Agregar información'}</Button>
        
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            />
        </Paper>
    );
}

export default FormularioInfoInicio;